import { InputMask, InputMaskProps } from '@react-input/mask';
import React, { forwardRef, Ref } from 'react';
import { TextInput, TextInputProps } from '../text-input';

type MaskedTextInputProps = TextInputProps & InputMaskProps;

export const MaskedTextInput = forwardRef(
  (props: MaskedTextInputProps, ref: Ref<HTMLInputElement>) => {
    return (
      <InputMask
        ref={ref}
        extraClassname="w-full"
        {...props}
        component={TextInput}
      />
    );
  },
);

MaskedTextInput.displayName = 'MaskedTextInput';
